<div class="container">
    <mat-table matSort multiTemplateDataRows [dataSource]="dataSource" background="#15151c" class="show-table">

        <ng-container matColumnDef="show">
            <mat-header-cell *matHeaderCellDef mat-sort-header> SHOW <app-sort-arrows-icon></app-sort-arrows-icon>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="show-name"> {{element.show}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="seasons">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered-cell"> SEASONS
                <app-sort-arrows-icon></app-sort-arrows-icon></mat-header-cell>
            <mat-cell *matCellDef="let element" class="centered-cell"> {{element.seasonsCount}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let row" class="action-cell">
                <div class="actions-buttons">
                    <button>
                        <app-move-arrow-icon (click)="moveShow(row)"></app-move-arrow-icon>
                    </button>

                    <button>
                        <app-drop-down-arrow *ngIf="!row.expandDetails" (click)="toggleDetails(row)"
                            [stroke]="'#50e3c2'"></app-drop-down-arrow>
                        <app-drop-down-arrow *ngIf="row.expandDetails" (click)="toggleDetails(row)" [stroke]="'#50e3c2'"
                            [pointUp]="true"></app-drop-down-arrow>
                    </button>
                </div>
            </mat-cell>
        </ng-container>


        <!-- Expanded details row -->

        <ng-container matColumnDef="expandedDetails">
            <mat-cell [attr.colspan]="displayedColumns.length + 1" *matCellDef="let element">

                <div class="season-table">
                    <div *ngFor="let season of element.seasons" class="season-row">
                        <div class="season-details-tab">
                            <div class="season-name">
                                {{season.name}}
                            </div>
                            <div class="season-air-dates">
                                {{season.airDateStart | date: 'MMM d yyyy'}} - {{season.airDateEnd | date: 'MMM d yyyy'}}
                            </div>
                            <app-drop-down-arrow *ngIf="!season.expandDetails" [stroke]="'#50e3c2'"
                                (click)="toggleDetails(season)"></app-drop-down-arrow>
                            <app-drop-down-arrow *ngIf="season.expandDetails" [stroke]="'#50e3c2'" [pointUp]="true"
                                (click)="toggleDetails(season)"></app-drop-down-arrow>
                        </div>

                        <div *ngIf="season.expandDetails" class="episodes">
                            <div *ngFor="let episode of season.episodes" class="episode-row">
                                <div class="episode-name-display">
                                    <span>S{{season.seasonNumber}} E{{episode.episodeNumber}} - {{episode.name}}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"
            [ngClass]="{'show-row-expanded':styleExpandedDetailsRow(row), 'show-row': !styleExpandedDetailsRow(row)}"></mat-row>

        <!-- Expanded details row definition -->
        <mat-row *matRowDef="let row; columns: ['expandedDetails'];"
            [ngClass]="{'details-expanded':styleExpandedDetailsRow(row), 'details-hidden': !styleExpandedDetailsRow(row)}"></mat-row>
    </mat-table>
</div>